const getColumnPosition = (columns) => {
  const positionArray = [];
  columns.map((column, index) => {
    const position = index === columns.length - 1 ? '-lst' : index === 0 ? '-frst' : '-cntr';
    positionArray.push(position);
  });
  return positionArray;
};

// SIMPLY version
const areObjEqual = (objA, objB) => {
  const aProps = Object.getOwnPropertyNames(objA);
  const bProps = Object.getOwnPropertyNames(objB);
  if (aProps.length !== bProps.length) {
    return false;
  }
  for (let i = 0; i < aProps.length; i++) {
    const propName = aProps[i];
    if (objA[propName] !== objB[propName]) {
      return false;
    }
  }
  return true;
};

const areArrayEqual = (arrayA, arrayB) => {
  if (arrayA.length !== arrayB.length) {
    return false;
  }
  for (let i = 0; i < arrayA.length; i++) {
    if (arrayA[i] !== arrayB[i]) {
      return false;
    }
  }
  return true;
};

const getFileType = (file) => {
  if (file) {
    const index = file.lastIndexOf('.');
    return file.slice(index + 1);
  }
  return 'no-file-type';
};

const ERROR_GRID_SEARCH = 1;
const ERROR_GRID_INITIAL = 2;

const callbackError = props => (error) => {
  props.setIsErrorGrid(error);
};

export default {
  getColumnPosition,
  areArrayEqual,
  areObjEqual,
  getFileType,
  callbackError,
  ERROR_GRID_INITIAL,
  ERROR_GRID_SEARCH,
};



// WEBPACK FOOTER //
// ./src/helpers/grid.helper.js